import React from "react";
import ReportActionsContainer from "./ReportActionsContainer";
import ReportTextContainer from "./ReportTextContainer";
import ReportingInfoContainer from "./ReportingInfoContainer";
import MeterContainer from "./MeterContainer";
import ProgressContainer from "./ProgressContainer";

const OperationBody = ({
  operationRef,
  commitment,
  operation,
  progress,
  startingDate,
  endingDate,
  setProgress,
  setCollapsed,
  saveReport,
  validateReport,
  meters,
  reportText,
  setMeters,
  setReportText,
  reportId,
  editing,
  progressContainerRef,
  textContainerRef,
  meterRefs
}) => {
  const modifyMeter = meter => {
    let modifiedMeters = undefined;
    if (meter.meterId) {
      modifiedMeters = meters.map(mappedMeter =>
        mappedMeter.meterId === meter.meterId
          ? { ...meter, commitmentOperationMeterRefId: meter.meterId }
          : mappedMeter
      );
    } else {
      modifiedMeters = meters.map(mappedMeter =>
        mappedMeter.commitmentOperationMeterRefId ===
        meter.commitmentOperationMeterRefId
          ? {
              ...meter,
              commitmentOperationMeterRefId: meter.commitmentOperationMeterRefId
            }
          : mappedMeter
      );
    }
    setMeters(modifiedMeters);
  };

  return (
    <div ref={operationRef} className="reporting">
      <ReportingInfoContainer
        startingDate={startingDate}
        endingDate={endingDate}
        setCollapsed={setCollapsed}
        operation={operation}
      />
      {meters.map((mappedMeter, index) => (
        <MeterContainer
          ref={meterRefs.current[index]}
          key={mappedMeter.meterId}
          meter={mappedMeter}
          index={index}
          modifyMeter={modifyMeter}
          reportId={reportId}
          //Disable 2035 meter for CIRCULAR_ECONOMY commitments.
          disabled={
            commitment.commitmentType === "CIRCULAR_ECONOMY" &&
            mappedMeter.meterDueDate === "2035"
          }
        />
      ))}

      <ProgressContainer
        ref={progressContainerRef}
        progress={progress}
        setProgress={setProgress}
      />

      <ReportTextContainer
        ref={textContainerRef}
        textKey={"sit.profile.operationReport.reportInFinnish"}
        reportText={reportText}
        setReportText={setReportText}
      />

      <ReportActionsContainer
        commitment={commitment}
        saveReport={saveReport}
        operation={operation}
        meters={meters}
        startingDate={startingDate}
        endingDate={endingDate}
        progress={progress}
        reportText={reportText}
        editing={editing}
        validateReport={validateReport}
      />
    </div>
  );
};

export default OperationBody;



// WEBPACK FOOTER //
// ./src/components/profile/reports/components/OperationBody.jsx